import styled, { css } from "styled-components";
import { FC } from "react";

import Text from "@/components/Text";
import { ReleaseStatusEnum } from "@/utils/enums";

interface StatusProps {
  $status: ReleaseStatusEnum;
}

const Status = styled.div<StatusProps>`
  background: ${({ theme }) => theme.colors.success};
  border-radius: 4px;
  padding: 6px 8px 5px;
  min-width: 62px;
  display: inline-block;
  text-align: center;
  ${({ $status }) =>
    $status === ReleaseStatusEnum.WAITING &&
    css`
      background: ${({ theme }) => theme.colors.warning};
    `}
  ${({ $status }) =>
    $status === ReleaseStatusEnum.SCHEDULED &&
    css`
      background: ${({ theme }) => theme.colors.info};
    `}
  ${({ $status }) =>
    $status === ReleaseStatusEnum.POSTED &&
    css`
      background: ${({ theme }) => theme.colors.success};
    `}
  ${({ $status }) =>
    $status === ReleaseStatusEnum.REJECTED &&
    css`
      background: ${({ theme }) => theme.colors.error};
    `}
    ${({ $status }) =>
    $status === ReleaseStatusEnum.DRAFT &&
    css`
      background: ${({ theme }) => theme.colors.darkGray};
    `}
    ${({ $status }) =>
    $status === ReleaseStatusEnum.PREPARED &&
    css`
      background: ${({ theme }) => theme.colors.distributionOrange};
    `}
`;

const StatusText = styled(Text)`
  font-size: 11px;
`;

const renderBadgeTitle = (status: ReleaseStatusEnum) => {
  switch (status) {
    case ReleaseStatusEnum.WAITING:
      return "Waiting";
    case ReleaseStatusEnum.SCHEDULED:
      return "Scheduled";
    case ReleaseStatusEnum.POSTED:
      return "Posted";
    case ReleaseStatusEnum.REJECTED:
      return "Rejected";
    case ReleaseStatusEnum.DRAFT:
      return "Draft";
    case ReleaseStatusEnum.PREPARED:
      return "Prepared";
  }
};

interface Props {
  status: ReleaseStatusEnum;
  className?: string;
}

const DistributionStatusBadge: FC<Props> = ({ status, className }) => {
  return (
    <Status className={className} $status={status}>
      <StatusText $color="white" $type="smallBold">
        {renderBadgeTitle(status)}
      </StatusText>
    </Status>
  );
};

export default DistributionStatusBadge;
